"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_text_mask_1 = __importDefault(require("react-text-mask"));
var TextMaskCustom = react_1.default.memo(function (_a) {
    var props = _a.props;
    var inputRef = props.inputRef, other = __rest(props, ["inputRef"]);
    var phoneNumberMask = ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
    var taxIdMask = [/\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/];
    var refCallBack = react_1.default.useCallback(function (ref) {
        if (ref === null || ref === void 0 ? void 0 : ref.inputElement) {
            ref.inputElement.focus();
        }
    }, []);
    var mask = props.name === "tax" ? taxIdMask : phoneNumberMask;
    return (react_1.default.createElement(react_text_mask_1.default, __assign({}, other, { ref: refCallBack, mask: mask, placeholderChar: "\u2000", showMask: true })));
});
exports.default = TextMaskCustom;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi9zcmMvQ29tcG9uZW50cy9jb21tb24vSE9DL1RleHRNYXNrL2luZGV4LnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7QUFBQSxnREFBMEI7QUFDMUIsb0VBQTBDO0FBVTFDLElBQU0sY0FBYyxHQUEwQixlQUFLLENBQUMsSUFBSSxDQUFDLFVBQUMsRUFBTztRQUFOLEtBQUssV0FBQTtJQUV0RCxJQUFBLFFBQVEsR0FBYyxLQUFLLFNBQW5CLEVBQUssS0FBSyxVQUFJLEtBQUssRUFBN0IsWUFBcUIsQ0FBRCxDQUFVO0lBRXBDLElBQU0sZUFBZSxHQUF3QixDQUFDLEdBQUcsRUFBRSxPQUFPLEVBQUUsSUFBSSxFQUFFLElBQUksRUFBRSxHQUFHLEVBQUUsR0FBRyxFQUFFLElBQUksRUFBRSxJQUFJLEVBQUUsSUFBSSxFQUFFLEdBQUcsRUFBRSxJQUFJLEVBQUUsSUFBSSxFQUFFLElBQUksRUFBRSxJQUFJLENBQUMsQ0FBQztJQUNqSSxJQUFNLFNBQVMsR0FBd0IsQ0FBQyxJQUFJLEVBQUUsSUFBSSxFQUFFLElBQUksRUFBRSxHQUFHLEVBQUUsSUFBSSxFQUFFLElBQUksRUFBRSxJQUFJLEVBQUUsR0FBRyxFQUFFLElBQUksRUFBRSxJQUFJLEVBQUUsSUFBSSxDQUFDLENBQUM7SUFFeEcsSUFBTSxXQUFXLEdBQUcsZUFBSyxDQUFDLFdBQVcsQ0FBQyxVQUFBLEdBQUc7UUFDdkMsSUFBSSxHQUFHLGFBQUgsR0FBRyx1QkFBSCxHQUFHLENBQUUsWUFBWSxFQUFFO1lBQ3JCLEdBQUcsQ0FBQyxZQUFZLENBQUMsS0FBSyxFQUFFLENBQUM7U0FDMUI7SUFDSCxDQUFDLEVBQUUsRUFBRSxDQUFDLENBQUE7SUFFTixJQUFNLElBQUksR0FBRyxLQUFLLENBQUMsSUFBSSxLQUFLLEtBQUssQ0FBQyxDQUFDLENBQUMsU0FBUyxDQUFDLENBQUMsQ0FBQyxlQUFlLENBQUM7SUFDaEUsT0FBTyxDQUNMLDhCQUFDLHlCQUFXLGVBQ04sS0FBSyxJQUNULEdBQUcsRUFBRSxXQUFXLEVBQ2hCLElBQUksRUFBRSxJQUFJLEVBQ1YsZUFBZSxFQUFFLFFBQVEsRUFDekIsUUFBUSxVQUNSLENBQ0gsQ0FBQztBQUNKLENBQUMsQ0FBQyxDQUFBO0FBRUYsa0JBQWUsY0FBYyxDQUFDIn0=